import React, { useEffect, useState } from 'react';

import Button from 'components/shared/Buttons/Button';
import Confirm from 'components/shared/Modal/Confirm/Confirm';
import Modal from 'components/shared/Modal/Modal';
import Allowed from 'components/shared/Permissions/Allowed';

import { tax_id_types } from '../../../../../constants';

import BillingProviderForm from './lib/BillingProviderForm';

export default function NewBillingProvider({
  formik,
  isLoading,
  open,
  type,
  handleClose,
  handleSubmit,
  states,
  loadedMembers,
  handleDeletion,
  isDeleting
}) {
  const currentState = states.find((state) => state.value == formik.values.bill_state);
  const currentBillTaxType = tax_id_types.find(
    (type) => type.value == formik.values.bill_taxid_type
  );
  const [selectedState, setSelectedState] = useState(currentState);
  const [practitioners, _] = useState(loadedMembers);
  const [selectedPractitioners, setSelectedPractitioners] = useState();
  const [deletionModal, setDeletionModal] = useState(false);

  useEffect(() => {
    if (practitioners.length == 1) {
      const newArr = [];
      newArr.push(practitioners[0].value);
      setSelectedPractitioners(practitioners[0]);
      formik.setFieldValue('practitioner_ids', newArr);
    }
    if (formik.values.practitioner_ids.length > 0) {
      const newArray = [];
      for (const f_practitioner of formik.values.practitioner_ids) {
        const foundPractitioner = practitioners.find((p) => p.value == f_practitioner);
        newArray.push(foundPractitioner);
      }
      setSelectedPractitioners(newArray);
    }
    if (formik.values.bill_taxid_type) {
      formik.setFieldValue('bill_taxid_type', currentBillTaxType);
    }
  }, []);
  const selectPractitioners = (e, v) => {
    setSelectedPractitioners(e);
    let newArr = [...formik.values.practitioner_ids];
    if (v.action === 'remove-value') {
      newArr = e.map((w) => w.value);
    } else if (v.action === 'select-option') {
      newArr.push(v.option.value);
    } else if (v.action === 'clear') {
      newArr = [];
    }
    formik.setFieldValue('practitioner_ids', newArr);
  };

  const customSelectStyle = {
    control: () => ({
      height: 40,
      display: 'flex',
      padding: '0px 6px',
      fontSize: 14,
      backgroundColor: '#f8f8f8',
      border: '1px solid #dcdcdc',
      borderRadius: '0.5rem'
    }),
    placeholder: (provided) => {
      return {
        ...provided,
        color: '#afafaf'
      };
    },
    singleValue: (provided) => {
      return {
        ...provided,
        fontWeight: 500
      };
    },
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 })
  };

  const handleSelectState = (state) => {
    setSelectedState(state);
    formik.setFieldValue('bill_state', state?.value);
  };

  const customModalTitle = (type) => {
    if (type == 'create') {
      return 'Create new billing provider';
    }
    if (type == 'update') {
      return 'Update billing provider';
    }
  };

  return (
    <>
      <Confirm
        isOpen={deletionModal}
        title="Delete Billing Provider"
        message="Are you sure you want to delete this billing provider?"
        variant="danger"
        icon="trash-mono"
        handleClose={() => setDeletionModal(false)}
        handleContinue={() => {
          handleDeletion(formik.values.id);
        }}
        loading={isDeleting}
      />
      <Modal
        className="min-w-[50dvw]"
        slideFromRight
        handleOpen={open}
        handleClose={handleClose}
        title={customModalTitle(type)}
        footer={
          <>
            <Button
              className="mr-auto"
              text="Cancel"
              outlined
              color="neutral"
              onClick={handleClose}
            />
            {formik.values.id && (
              <Allowed requiredPermissions="billing.delete">
                <Button text="Delete" color="danger" onClick={() => setDeletionModal(true)} />
              </Allowed>
            )}
            <Allowed requiredPermissions="billing.create">
              <Button
                text={customModalTitle(type)}
                primary
                onClick={handleSubmit}
                loading={isLoading}
              />
            </Allowed>
          </>
        }>
        <BillingProviderForm
          formik={formik}
          tax_id_types={tax_id_types}
          selectedState={selectedState}
          handleSelectState={handleSelectState}
          states={states}
          customSelectStyle={customSelectStyle}
          selectedPractitioners={selectedPractitioners}
          selectPractitioners={selectPractitioners}
          practitioners={practitioners}
        />
      </Modal>
    </>
  );
}
